import React from "react";

const SlideImage = ({
  images = [],
  imageHeight = "h-[150px]",
  applyImageOverlay = false,
  isIneligible = false,
  businessAvatar,
  onBack,
  illustration, // truyền vào nếu có hình minh họa góc phải trên
}) => {
  const mainImage = images?.[0];

  return (
    <div
      className={`relative w-full rounded-md overflow-hidden ${imageHeight}`}
    >
      {/* Overlay tím nhạt phía trên */}
      <div className={`absolute inset-0 bg-[#ECEEFF] ${imageHeight} w-full `} />
      {/* Hình minh họa góc phải trên */}
      {illustration && (
        <img
          src={illustration}
          alt="illustration"
          className="absolute bottom-0 right-4 z-20 w-[80px] h-[80px] object-contain"
        />
      )}
      {/* Ảnh thumbnail */}
      {mainImage && (
        <img
          src={mainImage}
          alt="quest-thumbnail"
          className={`w-full object-cover rounded-md ${imageHeight} relative z-0`}
        />
      )}
      {/* Overlay mờ nếu cần */}
      {applyImageOverlay && (
        <div className="absolute inset-0 bg-black bg-opacity-5 pointer-events-none z-20" />
      )}
      {/* Avatar shop */}
      {businessAvatar && (
        <div className="absolute top-8 left-8 z-30 w-[70px] h-[70px] rounded-md overflow-hidden bg-gray-100 shadow">
          <img
            src={businessAvatar}
            alt="Shop Avatar"
            className="w-full h-full object-cover"
          />
        </div>
      )}
      {/* Overlay trạng thái ineligible */}
      {isIneligible && (
        <div className="absolute inset-0 bg-[#E9E6E4] bg-opacity-60 pointer-events-none z-20" />
      )}
    </div>
  );
};

export default SlideImage;
